// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"hi","trustedRetailerTooltipWrapper":"ii"};